
import { NavLink } from 'react-router-dom';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
//import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
//import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
//import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
//import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
//import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
//import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
//import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import Tooltip from '@mui/material/Tooltip';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
//import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
//import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';


import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 50,
    height: 28,
    padding: 7,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(22px)',
            '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                    '#fff',
                )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
        width: 25,
        height: 25,
        '&::before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                '#fff',
            )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
        },
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        borderRadius: 20 / 2,
    },
}));

export default function SideNav({ online, darkMode, setDarkMode }) {
    const liClass = 'flex space-x-4 items-center py-2.5 px-7 font-normal hover:text-blue hover:stroke-blue hover:border-l-4 ease-in-out duration-100 hover:bg-gray-smoke text-noto';
    const iconColor = '#595c60';
    return (
        <>
            <div id="main-side-bar" className={'main-side-bar hidden md:flex flex-col justify-between side-nav side-nav-transparent side-nav-expand border-r border-slate-150 collapsed'}>
                <div>
                    <div className="side-nav-header ">
                        <div className="logo px-4 py-2">
                            <div className="svg-container">
                                <NavLink to="/" >
                                    <svg className="mx-auto" version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="95" x="0px" y="0px" viewBox="0 0 422.04 208.34" overflow="visible" xmlSpace="preserve" > <g> <g> <g> <path fill="#303B97" d="M381.86,111.47c0.08-0.7,0.15-1.41,0.21-2.12c-0.02,0.08-0.03,0.15-0.04,0.23 C381.99,110.21,381.93,110.84,381.86,111.47z" /> <path fill="#303B97" d="M382.26,104.74c0-0.67-0.01-1.34-0.03-2.01c0,1.21,0,2.41,0,3.62 C382.25,105.82,382.26,105.28,382.26,104.74z" /> <path fill="#303B97" d="M381.23,94.77c0.37,2.29,0.65,4.59,0.97,6.89c-0.61-13.09-5.51-25.15-13.33-34.84 c0.31,0.4,0.61,0.79,0.91,1.19C375.72,76.03,379.63,84.91,381.23,94.77z" /> <path fill="#303B97" d="M367.84,187.12c7.65-4.31,14.62-9.6,20.76-15.89c7.4-7.59,13.46-16.13,18.05-25.74 c5.2-10.89,8.12-22.32,9.02-34.31c0.03-0.42,0.2-0.83,0.31-1.24c0-3.45,0-6.89,0-10.34c-0.5-3.61-0.93-7.24-1.52-10.84 c-2.42-14.93-8.35-28.38-17.33-40.51c-10.18-13.74-23.23-23.97-38.91-30.58c-17.04-7.19-34.8-9.05-53.14-6.09 c-16.27,2.62-31.69,7.76-46.69,14.42c-17.42,7.73-33.93,17.08-49.7,27.72c-9.62,6.49-19.11,13.18-28.34,20.22 c-8.54,6.51-16.71,13.53-24.92,20.46c-2.71,2.29-5.11,4.96-7.55,7.57c-0.7,0.75-1,1.86-1.49,2.81c0,0.57,0,1.15,0,1.72 c2.63,5.52,7.55,8.91,12.08,12.55c10.62,8.52,21.27,17.02,32.22,25.1c13.67,10.1,28.04,19.15,42.96,27.33 c14.43,7.91,29.27,14.86,44.9,20.06c13.75,4.58,27.85,7.66,42.37,7.77C337.56,199.44,353.28,195.31,367.84,187.12z M291.45,162.66c-10.32-3.44-20.13-8.03-29.66-13.25c-9.85-5.4-19.34-11.39-28.37-18.05c-7.23-5.34-14.27-10.95-21.28-16.58 c-2.99-2.4-6.24-4.64-7.98-8.29c0-0.38,0-0.76,0-1.14c0.32-0.62,0.52-1.36,0.98-1.85c1.61-1.72,3.19-3.49,4.98-5 c5.43-4.58,10.82-9.21,16.46-13.51c6.09-4.64,12.37-9.07,18.72-13.35c10.42-7.03,21.33-13.2,32.83-18.31 c9.91-4.4,20.1-7.79,30.84-9.53c12.11-1.95,23.84-0.72,35.1,4.03c9.9,4.17,18.2,10.53,24.79,19 c7.82,9.68,12.71,21.75,13.33,34.84c0.01,0.09,0.02,0.18,0.04,0.27c0,0.27,0,0.53,0,0.8c0.02,0.67,0.03,1.34,0.03,2.01 c0,0.54-0.01,1.07-0.03,1.61c0,0.8,0,1.61,0,2.41c-0.05,0.2-0.12,0.39-0.16,0.59c-0.06,0.71-0.13,1.42-0.21,2.12 c-0.75,7.23-2.63,14.16-5.79,20.78c-3.03,6.35-7.03,11.99-11.92,17c-4.05,4.16-8.66,7.65-13.71,10.49c-9.61,5.41-20,8.14-31,8.05 C309.85,167.71,300.53,165.68,291.45,162.66z" /> <path fill="#303B97" d="M382.24,101.93c-0.01-0.09-0.02-0.18-0.04-0.27c0.02,0.36,0.03,0.71,0.04,1.07 C382.24,102.47,382.24,102.2,382.24,101.93z" /> <path fill="#303B97" d="M382.24,108.76c0-0.8,0-1.61,0-2.41c-0.03,1.01-0.09,2.01-0.16,3 C382.11,109.15,382.19,108.96,382.24,108.76z" /> </g> <g> <path fill="#FEBF12" d="M40.09,99.7c-0.08,0.7-0.15,1.41-0.21,2.12c0.02-0.08,0.03-0.15,0.04-0.23 C39.97,100.96,40.03,100.33,40.09,99.7z" /> <path fill="#FEBF12" d="M39.69,106.42c0,0.67,0.01,1.34,0.03,2.01c0-1.21,0-2.41,0-3.62C39.7,105.35,39.69,105.89,39.69,106.42z" /> <path fill="#FEBF12" d="M40.72,116.39c-0.37-2.29-0.65-4.59-0.97-6.89c0.61,13.09,5.51,25.15,13.33,34.84 c-0.31-0.4-0.61-0.79-0.91-1.19C46.24,135.14,42.32,126.26,40.72,116.39z" /> <path fill="#FEBF12" d="M54.12,24.05c-7.65,4.31-14.62,9.6-20.76,15.89c-7.4,7.59-13.46,16.13-18.05,25.74 C10.11,76.56,7.19,88,6.29,99.99c-0.03,0.42-0.2,0.83-0.31,1.24c0,3.45,0,6.89,0,10.34c0.5,3.61,0.93,7.24,1.52,10.84 c2.42,14.93,8.35,28.38,17.33,40.51c10.18,13.74,23.23,23.97,38.91,30.58c17.04,7.18,34.8,9.05,53.14,6.09 c16.27-2.62,31.69-7.76,46.69-14.42c17.42-7.73,33.93-17.08,49.7-27.72c9.62-6.49,19.11-13.18,28.34-20.21 c8.54-6.51,16.71-13.53,24.92-20.46c2.71-2.29,5.11-4.96,7.55-7.57c0.7-0.75,1-1.86,1.49-2.81c0-0.57,0-1.15,0-1.72 c-2.63-5.52-7.55-8.91-12.08-12.55c-10.62-8.52-21.27-17.02-32.22-25.1c-13.67-10.1-28.04-19.15-42.96-27.33 c-14.43-7.91-29.27-14.86-44.9-20.06c-13.75-4.58-27.85-7.66-42.37-7.77C84.4,11.72,68.67,15.85,54.12,24.05z M130.51,48.51 c10.32,3.44,20.13,8.03,29.66,13.25c9.85,5.4,19.34,11.39,28.37,18.05c7.23,5.34,14.27,10.95,21.28,16.58 c2.99,2.4,6.24,4.64,7.98,8.29c0,0.38,0,0.76,0,1.14c-0.32,0.62-0.52,1.36-0.98,1.85c-1.61,1.72-3.19,3.49-4.98,5 c-5.43,4.58-10.82,9.21-16.46,13.51c-6.09,4.64-12.37,9.07-18.72,13.35c-10.42,7.03-21.33,13.2-32.83,18.31 c-9.91,4.4-20.1,7.79-30.84,9.53c-12.11,1.95-23.84,0.72-35.1-4.03c-9.9-4.17-18.2-10.53-24.79-19 c-7.82-9.68-12.71-21.75-13.33-34.84c-0.01-0.09-0.02-0.18-0.04-0.27c0-0.27,0-0.53,0-0.8c-0.02-0.67-0.03-1.34-0.03-2.01 c0-0.54,0.01-1.07,0.03-1.61c0-0.8,0-1.61,0-2.41c0.05-0.2,0.12-0.39,0.16-0.59c0.06-0.71,0.13-1.42,0.21-2.12 c0.75-7.23,2.63-14.16,5.79-20.78c3.03-6.35,7.03-11.99,11.92-17c4.05-4.16,8.66-7.65,13.71-10.49c9.61-5.41,20-8.14,31-8.05 C112.11,43.45,121.42,45.48,130.51,48.51z" /> <path fill="#FEBF12" d="M39.72,109.23c0.01,0.09,0.02,0.18,0.04,0.27c-0.02-0.36-0.03-0.71-0.04-1.07 C39.72,108.7,39.72,108.97,39.72,109.23z" /> <path fill="#FEBF12" d="M39.72,102.41c0,0.8,0,1.61,0,2.41c0.03-1.01,0.09-2.01,0.16-3C39.84,102.01,39.77,102.21,39.72,102.41z" /> </g> </g> <path fill="#303B97" d="M180.34,73.94c-0.02,0.02-0.04,0.04-0.07,0.05c2.79,1.88,5.55,3.82,8.26,5.82 c7.23,5.34,14.27,10.95,21.28,16.58c0.48,0.38,0.96,0.76,1.44,1.14c5.04-4.26,10.08-8.55,15.33-12.56 c4.76-3.62,9.62-7.11,14.55-10.51c-3.27-2.51-6.55-5.01-9.86-7.45c-6.83-5.04-13.83-9.82-20.98-14.37 c-0.54,0.36-1.08,0.71-1.62,1.07C199.06,60.21,189.56,66.91,180.34,73.94z" /> <polygon fill="#303B97" points="179.6,74.51 211.04,52.15 242.47,72.64 241.14,74.48 208.79,99.7 	" /> </g> </svg>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div className="side-nav-content font-bold text-gray-dark">
                        <ul>
                            <li className='main-page-home'>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>แดชบอร์ด</span>} placement="right" arrow>
                                    <NavLink to="/" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <DashboardOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            แดชบอร์ด
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>แชท</span>} placement="right" arrow>
                                    <NavLink to="/chat" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <QuestionAnswerOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            แชท
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>
                        </ul>


                        <ul>
                            <li>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>ลูกค้า</span>} placement="right" arrow>
                                    <NavLink to="/leads" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <PeopleAltOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            ลูกค้า
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>


                            <li>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>สินค้า / บริการ</span>} placement="right" arrow>
                                    <NavLink to="/products" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <StorefrontOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            สินค้า / บริการ
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>คำสั่งซื้อ</span>} placement="right" arrow>
                                    <NavLink to="/orders" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <ShoppingCartOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            คำสั่งซื้อ
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>ไฟล์</span>} placement="right" arrow>
                                    <NavLink to="/files" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <FolderZipOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            ไฟล์
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>

                            <li>
                                <Tooltip title={<span style={{ fontSize: '16px' }}>รายงาน</span>} placement="right" arrow>
                                    <NavLink to="/report" className={liClass}>
                                        <span className='menu-svg-warp'>
                                            <ShowChartOutlinedIcon sx={{ color: iconColor }} />
                                        </span>
                                        <span className='menu-link-warp'>
                                            รายงาน
                                        </span>
                                    </NavLink>
                                </Tooltip>
                            </li>
                        </ul>




                    </div>
                </div>


                <div>
                    <ul className='mb-2'>
                        <li className='flex justify-center items-center'>
                            <div className=' rotate-90'>
                                <FormControlLabel
                                    control={<MaterialUISwitch sx={{ m: 1 }}

                                        onChange={(e) => {
                                            setDarkMode(e.target.checked);
                                            //localStorage.setItem('darkmode', e.target.checked);
                                        }}
                                        checked={darkMode}
                                    />}
                                />
                            </div>
                        </li>
                        <li>
                            <Tooltip title={<span style={{ fontSize: '16px' }}>{online ? 'ออนไลน์' : 'ออฟไลน์'} </span>} placement="right" arrow>
                                <div className='flex justify-center items-center'>
                                    <span className="relative flex h-3 w-3">
                                        {online ?
                                            <>
                                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-600 opacity-75"></span>
                                                <span className="relative inline-flex rounded-full h-3 w-3 bg-indigo-800"></span>
                                            </> :
                                            <>
                                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-600 opacity-75"></span>
                                                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-800"></span>
                                            </>
                                        }
                                    </span>
                                </div>

                            </Tooltip>
                        </li>
                        <li className='main-page-home'>
                            <Tooltip title={<span style={{ fontSize: '16px' }}>ออกจากระบบ</span>} placement="right" arrow>
                                <NavLink to="/logout" className={liClass}>
                                    <span className='menu-svg-warp'>
                                        <LogoutOutlinedIcon sx={{ color: iconColor }} />
                                    </span>
                                    <span className='menu-link-warp'>
                                        ออกจากระบบ
                                    </span>
                                </NavLink>
                            </Tooltip>
                        </li>
                    </ul>
                </div>
            </div >
        </>
    )
}